import { styled } from '@styles';

export const Wrapper = styled.div`
  @media (max-width: 767px) {
    padding-bottom: 186px;
  }
`;

export const Header = styled.div`
  text-align: center;
  padding: 2rem;
`;
